export const forecastMultiples = [
    'straight-forecast',
    'reverse-forecast',
    'combination-forecast',
    'straight-tricast',
    'combination-tricast',
]

export const specialMultiples = {
    TRIXIE: 'trixie',
    PATENT: 'patent',
    YANKEE: 'yankee',
    LUCKY_15: 'lucky-15',
    CANADIAN: 'canadian',
    LUCKY_31: 'lucky-31',
    HEINZ: 'heinz',
    LUCKY_63: 'lucky-63',
    SUPER_HEINZ: 'super-heinz',
    GOLIATH: 'goliath',
}

const betSizes = {
    SINGLE: 1,
    DOUBLE: 2,
    TREBLE: 3,
    FOUR_FOLD: 4,
    FIVE_FOLD: 5,
    SIX_FOLD: 6,
    SEVEN_FOLD: 7,
    EIGHT_FOLD: 8,
}

export const specialCombos = {
    // 3 selections -> 3 doubles, 1 treble (4)
    [specialMultiples.TRIXIE]: [
        betSizes.DOUBLE,
        betSizes.TREBLE,
    ],

    // 3 selections -> 3 singles, 3 doubles, 1 treble (7)
    [specialMultiples.PATENT]: [
        betSizes.SINGLE,
        betSizes.DOUBLE,
        betSizes.TREBLE,
    ],

    // 4 selections -> 6 doubles, 4 trebles, 1 4-fold (11)
    [specialMultiples.YANKEE]: [
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
    ],

    // 4 selections -> 4 singles, 6 doubles, 4 trebles, 1 4-fold (15)
    [specialMultiples.LUCKY_15]: [
        betSizes.SINGLE,
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
    ],

    // 5 selections -> 10 doubles, 10 trebles, 5 4-folds, 1 5-fold (26)
    [specialMultiples.CANADIAN]: [
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
        betSizes.FIVE_FOLD,
    ],

    // 5 selections -> 5 singles, 10 doubles, 10 trebles, 5 4-folds, 1 5-fold (31)
    [specialMultiples.LUCKY_31]: [
        betSizes.SINGLE,
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
        betSizes.FIVE_FOLD,
    ],

    // 6 selections -> 15 doubles, 20 trebles, 15 4-folds, 6 5-folds, 1 6-fold (57)
    [specialMultiples.HEINZ]: [
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
        betSizes.FIVE_FOLD,
        betSizes.SIX_FOLD,
    ],

    // 6 selections -> 6 singles, 15 doubles, 20 trebles, 4 4-folds, 6 5-folds, 1 6-fold (63)
    [specialMultiples.LUCKY_63]: [
        betSizes.SINGLE,
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
        betSizes.FIVE_FOLD,
        betSizes.SIX_FOLD,
    ],

    // 7 selections -> 21 doubles, 35 trebles, 35 4-folds, 21 5-folds, 7 6-folds, 1 7-fold (120)
    [specialMultiples.SUPER_HEINZ]: [
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
        betSizes.FIVE_FOLD,
        betSizes.SIX_FOLD,
        betSizes.SEVEN_FOLD,
    ],

    // 8 selections ->
    // 28 doubles, 56 trebles,70 4-fold, 56 5-fold, 28 6-fold, 8 7-folds, 1 8-fold (247)
    [specialMultiples.GOLIATH]: [
        betSizes.DOUBLE,
        betSizes.TREBLE,
        betSizes.FOUR_FOLD,
        betSizes.FIVE_FOLD,
        betSizes.SIX_FOLD,
        betSizes.SEVEN_FOLD,
        betSizes.EIGHT_FOLD,
    ],
}

/* eslint max-len: 0 */
export const multiplesInfo = {
    double: {
        formTitle: 'Double',
        title: 'Doubles',
        body: `A Double consists of 1 bet involving 2 selections from different races.

        Both must be successful to get a return.`,
    },
    treble: {
        formTitle: 'Treble',
        title: 'Trebles',
        body: `A Treble consists of 1 bet involving 3 selections from different races.

        All must be successful to get a return.`,
    },
    trixie: {
        formTitle: 'Trixie',
        title: 'Trixies',
        body: `A Trixie consists of 4 bets involving 3 selections from different races.

        “3 Double bets & 1 Treble bet.”

        A minimum of 2 successful selections will guarantee a return.`,
    },
    patent: {
        formTitle: 'Patent',
        title: 'Patents',
        body: `A Patent consists of 7 bets involving 3 selections from different races.

        “3 Single bets, 3 Double bets & 1 Treble bet.”

        Just one successful selection will guarantee a return.`,
    },
    yankee: {
        formTitle: 'Yankee',
        title: 'Yankee',
        body: `A Yankee consists of 11 bets involving 4 selections from different races.

        "6 Double bets, 4 Treble bets & 1 Fourfold Accumulator bet."

        A minimum of 2 successful selections will guarantee a return.`,
    },
    'lucky-15': {
        formTitle: 'Lucky 15',
        title: 'Lucky 15',
        body: `A Lucky 15 consists of 15 bets involving 4 selections from different races.

        "4 Single bets, 6 Double bets, 4 Treble bets, & 1 Fourfold Accumulator bet."

        Just one successful selection will guarantee a return.`,
    },
    canadian: {
        formTitle: 'Canadian',
        title: 'Canadian',
        body: `A Canadian consists of 26 bets involving 5 selections from different races.

        "10 Double bets, 10 Treble bets, 5 Fourfold Accumulators & 1 Fivefold Accumulator."

        A minimum of 2 successful selections will guarantee a return.`,
    },
    'lucky-31': {
        formTitle: 'Lucky 31',
        title: 'Lucky 31',
        body: `A Lucky 31 consists of 31 bets involving 5 selections from different races.

        "5 Single bets, 10 Double bets, 10 Treble bets, 5 Fourfold Accumulators & 1 Fivefold Accumulator."

        Just one successful selection will guarantee a return.`,
    },
    heinz: {
        formTitle: 'Heinz',
        title: 'Heinz',
        body: `A Heinz consists of 57 bets involving 6 selections from different races.

        "15 Double bets, 20 Treble bets, 15 Fourfold Accumulators, 6 Fivefold Accumulators & 1 Sixfold Accumulator."

        A minimum of 2 successful selections will guarantee a return.`,
    },
    'lucky-63': {
        formTitle: 'Lucky 63',
        title: 'Lucky 63',
        body: `A Lucky 63 consists of 63 bets involving 6 selections from different races.

        "6 Single bets, 15 Double bets, 20 Treble bets, 15 Fourfold Accumulators, 6 Fivefold Accumulators & 1 Sixfold Accumulator."

        Just one successful selection will guarantee a return.`,
    },
    'super-heinz': {
        formTitle: 'Super Heinz',
        title: 'Super Heinz',
        body: `A Super Heniz consists of 120 bets involving 7 selections from different races.

        "21 Double bets, 35 Treble bets, 35 Fourfold Accumulators, 21 Fivefold Accumulators, 7 Sixfold Accumulators & 1 Sevenfold Accumulator."

        A minimum of 2 successful selections will guarantee a return.`,
    },
    goliath: {
        formTitle: 'Goliath',
        title: 'Goliath',
        body: `A Goliath consists of 247 bets involving 8 selections from different races.

        "28 Double bets, 56 Treble bets, 70 Fourfold Accumulators, 56 Fivefold Accumulators, 28 Sixfold Accumulators, 8 Sevenfold Accumulators & 1 Eightfold Accumulator."

        A minimum of 2 successful selections will guarantee a return.`,
    },
    accumulator: {
        formTitle: 'Accumulator',
        title: 'Accumulator',
        body: `An Accumulator consists of 1 bet involving 4 or more selections from different races.

        All selections must be successful to guarantee a return.`,
    },
    'straight-forecast': {
        formTitle: 'Forecast',
        title: 'Forecast',
        body: `A Forecast consists of 2 selections from the same race and asks you to predict who will finish 1st and 2nd in that order.

        You can order your forecast by tapping the arrows next to your selections.`,
    },
    'combination-forecast': {
        formTitle: 'Combi Forecast',
        title: 'Combi Forecast',
        body: 'A Combi Forecast consists of 3 or more selections from the same race this bet is made up a multiple separate bets these are a combination of all selected horses finishing 1st and 2nd.',
    },
    'reverse-forecast': {
        formTitle: 'Reverse Forecast',
        title: 'Reverse Forecast',
        body: 'A Reverse Forecast consists of 2 selections from the same race this bet is made up a 2 separate bets these are a combination of either horse finishing 1st and 2nd.',
    },
    'straight-tricast': {
        formTitle: 'Tricast',
        title: 'Tricast',
        body: `A Tricast consists of 3 selections from the same race and asks you to predict who will finish 1st, 2nd and 3rd in that order.

        You can order your forecast by tapping the arrows next to your selections.`,
    },
    'combination-tricast': {
        formTitle: 'Combi Tricast',
        title: 'Combi Tricast',
        body: 'A Combi Tricast consists of 3 or more selections from the same race this bet is made up a multiple separate bets these are a combination of all selected horses finishing 1st, 2nd and 3rd.',
    },
}

export const accaNames = {
    'accumulator-4': 'Fourfold Accumulator',
    'accumulator-5': 'Fivefold Accumulator',
    'accumulator-6': 'Sixfold Accumulator',
    'accumulator-7': 'Sevenfold Accumulator',
    'accumulator-8': 'Eightfold Accumulator',
    'accumulator-9': 'Ninefold Accumulator',
    'accumulator-10': 'Tenfold Accumulator',
    'accumulator-11': 'Accumulator',
    'accumulator-12': 'Accumulator',
    'accumulator-13': 'Accumulator',
    'accumulator-14': 'Accumulator',
    'accumulator-15': 'Accumulator',
    'accumulator-16': 'Accumulator',
    'accumulator-17': 'Accumulator',
    'accumulator-18': 'Accumulator',
    'accumulator-19': 'Accumulator',
    'accumulator-20': 'Accumulator',
    'accumulator-21': 'Accumulator',
    'accumulator-22': 'Accumulator',
    'accumulator-23': 'Accumulator',
    'accumulator-24': 'Accumulator',
}



// WEBPACK FOOTER //
// /src/js/common/utils/multiples.js